import React from 'react';
import { Form, Input, Select, Button } from 'antd';

const { TextArea } = Input;

interface LocationFormProps {
  form: any;
  initialValues?: any;
  onFinish: (values: any) => void;
  loading?: boolean;
  submitText?: string;
  hideFields?: string[];
  companies?: any[];
  locations?: any[];
  isSuperAdmin?: boolean;
  currentUser?: any;
  editingLocation?: any;
}

const LocationForm: React.FC<LocationFormProps> = ({
  form,
  initialValues = {},
  onFinish,
  loading = false,
  submitText = 'Lưu',
  hideFields = [],
  companies = [],
  locations = [],
  isSuperAdmin = false,
  currentUser,
  editingLocation,
}) => {
  return (
    <Form form={form} layout="vertical" onFinish={onFinish}>
      {!hideFields.includes('name') && (
        <Form.Item 
          name="name" 
          label="Tên vị trí" 
          rules={[{ required: true, message: 'Nhập tên vị trí!' }]}
        > 
          <Input 
            className="ams-input" 
            placeholder="Tên vị trí" 
            size="large" 
            style={{ width: '100%', borderRadius: 8, height: 40 }} 
          />
        </Form.Item>
      )}
      
      {!hideFields.includes('description') && (
        <Form.Item name="description" label="Mô tả">
          <TextArea 
            className="ams-input" 
            placeholder="Mô tả vị trí" 
            rows={3} 
            style={{ width: '100%', borderRadius: 8 }} 
          />
        </Form.Item>
      )}
      
      {/* Trường công ty */}
      {!hideFields.includes('company_id') && isSuperAdmin ? (
        <Form.Item 
          name="company_id" 
          label="Công ty" 
          rules={[{ required: true, message: 'Chọn công ty!' }]}
        >
          <Select
            className="ams-input"
            placeholder="Chọn công ty"
            size="large"
            style={{ width: '100%', borderRadius: 8, height: 40 }}
            options={companies.map((company: any) => ({
              value: company.id,
              label: company.name,
            }))}
            // Không disable cho superadmin
            showSearch
            filterOption={(input, option) =>
              (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }
          />
        </Form.Item>
      ) : !hideFields.includes('company_id') && (
        <Form.Item label="Công ty">
          <Input
            value={companies.find((c: any) => c.id === currentUser?.company_id)?.name || ''}
            disabled
            size="large"
            style={{ width: '100%', borderRadius: 8, height: 40 }}
          />
        </Form.Item>
      )}
      
      {!hideFields.includes('parent_location_id') && (
        <Form.Item name="parent_location_id" label="Vị trí cha">
          <Select
            className="ams-input"
            placeholder="Chọn vị trí cha (tùy chọn)"
            size="large"
            style={{ width: '100%', borderRadius: 8, height: 40 }}
            allowClear
            showSearch
            filterOption={(input, option) =>
              (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }
            options={locations
              .filter((loc: any) => !editingLocation || loc.id !== editingLocation.id)
              .map((location: any) => ({
                value: location.id,
                label: location.name,
              }))}
          />
        </Form.Item>
      )}
      
      <Form.Item style={{ marginBottom: 0 }}>
        <Button 
          className="ams-btn" 
          type="primary" 
          htmlType="submit" 
          size="large" 
          loading={loading}
          style={{ width: '100%', borderRadius: 8, height: 40 }}
        >
          {submitText}
        </Button>
      </Form.Item>
    </Form>
  );
};

export default LocationForm; 